export default class ResourceLoader {

	private static loaded = {};

	public static loadScript(url: string, onLoaded?: () => void) {
		if (!ResourceLoader.loaded[url]) {
			const head = document.head;
			const link = document.createElement("script");

			link.type = "text/javascript";
			link.src = url;
			link.addEventListener('load', () => {
				ResourceLoader.loaded[url] = true;
				if (onLoaded) {
					onLoaded();
				}
			});

			head.appendChild(link);
		} else {
			if (onLoaded) {
				onLoaded();
			}
		}
	}

	public static loadStyle(url: string) {
		const head = document.head;
		const link = document.createElement("link");

		link.type = "text/css";
		link.rel = "stylesheet";
		link.href = url;

		head.appendChild(link);
	}

	public static loadFavicon(url: string) {
		let link: HTMLLinkElement = document.querySelector('link[rel=\"shortcut icon\"]');

		if (!link || link.tagName !== 'link') {
			link = document.createElement('link');
			link.rel = 'shortcut icon';
			document.head.appendChild(link);
		}

		link.href = url;
	}

	public static loadMetaTags(metaTags: string) {
		try {
			let metas = JSON.parse(metaTags);

			Object.keys(metas).forEach(function (key) {
				var metaTag = document.createElement('meta');

				metaTag.name = key;
				metaTag.content = metas[key];

				document.head.appendChild(metaTag);
			});
		} catch {
			console.error("Error while loading Meta Tages: Invalid json format!!")
		}
	}

}



// WEBPACK FOOTER //
// ./src/core/util/resource/ResourceLoader.ts